import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(-360deg);
	}
`;

const checkAnimation = keyframes`
	0% {
		opacity:1;
		width:0px;
		height:0px;
	}
	50% {
		width:40px;
		height:0px;
	}
	100% {
		opacity:1;
		height:80px;
	}
`;

export const Wrapper = styled.div`
	width: 200px;
	height: 200px;
	border: 0px solid transparent;
	margin: 0 auto;
	border-radius: 50%;
	position: relative;
	background-color: #ccc;
	overflow: hidden;
`;

const InnerCircle = styled.div`
	position: absolute;
	top: 15px;
	left: 15px;
	margin: auto auto;
	background-color: white;
	width: 85%;
	height: 85%;
	display: block;
	border-radius: 50%;
`;

const Mask = styled.div`
	content: ' ';
	position: absolute;
	right: 0px;
	height: 200px;
	width: 100px;
	border-radius: 0 100px 100px 0px;
	background-color: #fff;
	transition-delay: 0.3s;
	opacity: 0;
`;

const Spinner = styled.div`
	content: ' ';
	position: absolute;
	top: 0px;
	right: 0px;
	border-radius: 0 100px 100px 0px;
	height: 200px;
	width: 100px;
	background-color: #0f9d58;
	transform-origin: left center;
	animation: ${rotateAnimation} 0.6s linear;
`;

const Filler = styled.div`
	content: ' ';
	position: absolute;
	opacity: 1;
	top: 0px;
	left: 0px;
	border-radius: 100px 0px 0px 100px;
	height: 200px;
	width: 100px;
	background-color: #0f9d58;
	transform-origin: left center;
	transition-delay: 0.3s;
`;

const Check = styled.div`
	opacity: 0;
	width: 40px;
	height: 40px;
	position: absolute;
	right: 145px;
	bottom: 100px;
	border-bottom: 8px solid #0f9d58;
	border-left: 8px solid #0f9d58;
	transform: scaleX(-1) rotate(-45deg);
	transform-origin: right bottom;
	animation: ${checkAnimation} 0.6s cubic-bezier(0.87, -0.41, 0.19, 1.44) 0.6s forwards;
`;

export class AnimatedCheckmark extends Component {
	constructor(props) {
		super(props);
		this.props = props;
	}

	render() {
		return (
			<Wrapper>
				<Spinner />
				<Mask />
				<Filler />
				<InnerCircle />
				<Check />
			</Wrapper>
		);
	}
}

export default AnimatedCheckmark;
